import "core-js/modules/es.array.push.js";
import { defineComponent as L, computed as o, useCssModule as j, resolveComponent as h, openBlock as a, createBlock as S, createSlots as F, withCtx as n, createElementVNode as I, normalizeClass as u, createElementBlock as m, renderSlot as i, createCommentVNode as g, withDirectives as H, mergeProps as R, toDisplayString as q, Fragment as U, renderList as T, vModelSelect as G, createVNode as J } from "vue";
import K from "../icon/comps/caret-down.vue.mjs";
import Q from "../labelStandalone/CdrLabelStandalone.vue.mjs";
import W from "../formError/CdrFormError.vue.mjs";
import X from "../../props/size.mjs";
import Y from "../../props/background.mjs";
import Z from "../../utils/mapClasses.mjs";
import _ from "../../utils/uid.mjs";
import x from "./styles/CdrSelect.module.scss.mjs";
import ee from "../../../_virtual/_plugin-vue_export-helper.mjs";
const re = L({
  name: "CdrSelect",
  components: {
    IconCaretDown: K,
    CdrLabelStandalone: Q,
    CdrFormError: W
  },
  inheritAttrs: !1,
  props: {
    /**
     * Custom ID that is mapped to the label ‘for’ attribute. If this value is not set, it will be auto-generated.
    */
    id: {
      type: String
    },
    /**
     * Sets the text value for the select label.
     * Required for accessibility compliance. Use ‘hideLabel’ to
     * visually hide the label but keep it available to screenreaders.
    */
    label: {
      type: String,
      required: !0
    },
    /**
     * Visually hides the label element, but leaves it available to screen readers for accessibility compliance.
     */
    hideLabel: {
      type: Boolean,
      default: !1
    },
    /**
     * Adds an option that is disabled and selected by default to serve as a `placeholder` for the select.
    */
    prompt: String,
    /**
     * Build options programmatically with data.
     * Provide an array of objects [{ text: String, value: String}] for greater control
     * or provide an array of strings ['String'] for simpler setup (value and text will be the same).
    */
    options: {
      type: Array
    },
    /**
     * Sets the background color the radio button is rendered on
     * @values primary, secondary
     */
    background: Y,
    /**
     * Sets the component's size; values can target responsive breakpoints. Example `small@lg`
     * @demoSelectMultiple false
     * @values small, medium, large
    */
    size: X,
    /** Sets the select to an error state, displays the `error` slot if one is present. */
    error: {
      type: [Boolean, String],
      default: !1
    },
    /**
    * Sets the `role` attribute for the embedded error state messaging.
    */
    errorRole: {
      type: String,
      default: "status"
    },
    /** @ignore */
    modelValue: {
      type: [String, Number, Boolean, Object, Array, Symbol, Function]
    },
    /** Disables the input and sets appropriate styling */
    disabled: Boolean,
    /** Sets aria-required on the input field and displays an asterisk next to the select label */
    required: Boolean,
    /** Displays '(optional)' text next to the select label. */
    optional: Boolean,
    /** Turns CdrSelect into a multi-select element. */
    multiple: Boolean,
    /** Sets the height of the CdrSelect when using the multiple option.
     * This number corresponds to the number of select options that will be visible without scrolling.
     */
    multipleSize: Number
  },
  emits: {
    /**
     * Event emitted by v-model on the radio's <input> element
     * @param modelValue
     */
    "update:modelValue": null
  },
  customOptions: {},
  setup(e, r) {
    const p = "cdr-select", $ = r.slots["helper-text"], k = r.slots.info, v = r.slots["info-action"], d = r.slots["pre-icon"], c = e.id ? e.id : _(), f = o(() => e.multiple && "cdr-select--multiple"), l = o(() => !e.modelValue && "cdr-select__prompt"), z = o(() => d && "cdr-select--preicon"), B = o(() => e.error && "cdr-select--error"), V = o(() => `cdr-select--${e.background}`), M = o(() => e.size && `${p}--${e.size}`), w = o(() => e.disabled && "cdr-select__caret--disabled"), A = o(() => {
      const s = [r.slots["helper-text"] ? `${e.id}-helper-text-top` : "", r.attrs["aria-describedby"]].filter((t) => t).join(" ");
      return e.error ? `${e.id}-error` : s;
    }), D = o(() => {
      const s = [];
      return e.options && e.options.forEach((t) => {
        const b = {};
        let y = "", C = "";
        if (typeof t == "string")
          y = t, C = t;
        else {
          const {
            text: P,
            value: E
          } = t;
          y = P, C = E;
        }
        b.text = y, b.value = C, s.push(b);
      }), s;
    }), N = o({
      get() {
        return e.modelValue;
      },
      set(s) {
        r.emit("update:modelValue", s);
      }
    }), O = j();
    return {
      mapClasses: Z,
      baseClass: p,
      hasHelper: $,
      hasInfo: k,
      hasInfoAction: v,
      hasPreIcon: d,
      uniqueId: c,
      multipleClass: f,
      promptClass: l,
      preIconClass: z,
      errorClass: B,
      backgroundClass: V,
      sizeClass: M,
      caretDisabledClass: w,
      describedby: A,
      computedOpts: D,
      selectModel: N,
      style: O
    };
  }
}), oe = ["id", "multiple", "size", "disabled", "aria-required", "aria-invalid", "aria-errormessage", "aria-describedby", "value"], le = ["value"];
function se(e, r, p, $, k, v) {
  const d = h("icon-caret-down"), c = h("cdr-form-error"), f = h("cdr-label-standalone");
  return a(), S(f, {
    "for-id": e.uniqueId,
    label: e.label,
    "hide-label": e.hideLabel,
    required: e.required,
    optional: e.optional,
    disabled: e.disabled
  }, F({
    default: n(() => [I("div", {
      class: u(e.style["cdr-select-wrap"])
    }, [e.hasPreIcon ? (a(), m("span", {
      key: 0,
      class: u(e.style["cdr-select__pre-icon"])
    }, [i(e.$slots, "pre-icon")], 2)) : g("", !0), H(I("select", R({
      id: e.uniqueId,
      class: e.mapClasses(e.style, e.baseClass, e.sizeClass, e.promptClass, e.multipleClass, e.backgroundClass, e.errorClass, e.preIconClass),
      multiple: e.multiple,
      size: e.multipleSize,
      disabled: e.disabled,
      "aria-required": e.required || null,
      "aria-invalid": !!e.error || null,
      "aria-errormessage": !!e.error && `${e.uniqueId}-error` || null
    }, e.$attrs, {
      "aria-describedby": e.describedby || null,
      value: e.modelValue,
      "onUpdate:modelValue": r[0] || (r[0] = (l) => e.selectModel = l)
    }), [e.prompt ? (a(), m("option", {
      key: 0,
      class: u(e.style["cdr-select__prompt"]),
      value: "",
      disabled: ""
    }, q(e.prompt), 3)) : g("", !0), (a(!0), m(U, null, T(e.computedOpts, (l) => (a(), m("option", {
      key: l.text,
      value: l.value
    }, q(l.text), 9, le))), 128)), i(e.$slots, "default")], 16, oe), [[G, e.selectModel]]), J(d, {
      class: u(e.mapClasses(e.style, "cdr-select__caret", e.caretDisabledClass))
    }, null, 8, ["class"])], 2)]),
    _: 2
  }, [e.hasHelper ? {
    name: "helper",
    fn: n(() => [i(e.$slots, "helper-text")]),
    key: "0"
  } : void 0, e.hasInfo ? {
    name: "info",
    fn: n(() => [i(e.$slots, "info")]),
    key: "1"
  } : void 0, e.hasInfoAction ? {
    name: "info-action",
    fn: n(() => [i(e.$slots, "info-action")]),
    key: "2"
  } : void 0, e.error ? {
    name: "error",
    fn: n(() => [e.error ? (a(), S(c, {
      key: 0,
      error: e.error,
      role: e.errorRole,
      id: `${e.uniqueId}-error`
    }, {
      error: n(() => [i(e.$slots, "error")]),
      _: 3
    }, 8, ["error", "role", "id"])) : g("", !0)]),
    key: "3"
  } : void 0]), 1032, ["for-id", "label", "hide-label", "required", "optional", "disabled"]);
}
const te = {
  $style: x
}, Ce = /* @__PURE__ */ ee(re, [["render", se], ["__cssModules", te]]);
export {
  Ce as default
};
